var _g, _polygon;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconToolbarConfirmedOn = function SvgIconToolbarConfirmedOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_11_",
    fill: "#488BE6",
    cx: 16.6,
    cy: 16.5,
    r: 15.2
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    fill: "#FFFFFF",
    points: "8.8,17.5 14.5,23.2 25.3,12.4 22.7,9.8 14.4,17.9 11.3,14.8 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconToolbarConfirmedOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-toolbar-confirmed-on.6c7a2996.svg";
export { ForwardRef as ReactComponent };